import { DateRangePicker } from "@/components/common/DateRangePicker";
import { DateRange } from "@/hooks/useDateRange";
import React from "react";

export interface RoomFilterProps {
  range: DateRange;
  onChange: (value: DateRange) => void;
}

const CreatedAtFilter: React.FC<RoomFilterProps> = ({ range, onChange }) => {
  return (
    <DateRangePicker
      dateRange={range}
      onDateRangeChange={onChange}
      triggerVariant="new_outline"
    />
  );
};

export default CreatedAtFilter;
